import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { Permission, PermissionEntitiesNames } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/')({
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { hasAllowedPermissionToResource, isInternalRole },
      featureFlags,
    } = context;

    const isAllowed =
      isInternalRole ||
      (hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.MEASUREMENT, permission: Permission.CREATE }) &&
        !!featureFlags[FeatureFlags.MeasurementsCodeEdit]);
    context.validatePermissions({ isAllowed, preload });
  },
});
